// extracted by mini-css-extract-plugin
export var collapsedSummary = "_sk-0";